module.exports = __webpack_public_path__ + "static/img/问界 M9.94f60e9d.png";